export enum AuthorityGroup {
  REGISTER_GROUP_REPORT = '1.6.5',
  REGISTER_GROUP_EDIT = '1.6.4',
  REGISTER_GROUP_DELETE = '1.6.3',
  REGISTER_GROUP_ADD = '1.6.2',
  REGISTER_GROUP_VIEW = '1.6.1',
  REGISTER_GROUP_REGISTRATION = '1.6',

  REGISTER_SUBGROUP_REPORTS = '1.7.5',
  REGISTER_SUBGROUP_EDIT = '1.7.4',
  REGISTER_SUBGROUP_DELETE = '1.7.3',
  REGISTER_SUBGROUP_ADD = '1.7.2',
  REGISTER_SUBGROUP_VIEW = '1.7.1',
  REGISTER_SUBGROUP_REGISTRATION = '1.7',
}
